export const PINCODE_MAP_ASSISTANT_LIMITS = {
  chatHistoryLimit: 20,
  maxConversationTurns: 8,
  defaultTimeoutMs: 30000,
};

export const PINCODE_MAP_ASSISTANT_API = {
  askEndpoint: "/pincode-chat/assistant/ask",
  defaultMethod: "GET",
  postMethod: "POST",
  jsonContentType: "application/json",
  headerClientId: "x-client-id",
  headerAuthorization: "Authorization",
  bearerPrefix: "Bearer",
  userInfoStorageKey: "userinfo",
  undefinedStorageValue: "undefined",
  fallbackClientId: "hubops-ui",
  abortErrorName: "AbortError",
  errorBaseUrlNotConfigured: "Pincode chat base URL is not configured.",
  errorRequestTimedOut: "Pincode assistant request timed out.",
  errorRequestFailedPrefix: "Pincode assistant request failed",
};

export const PINCODE_MAP_ASSISTANT_SUGGESTIONS = [
  "Is 560001 serviceable for courier, e-commerce, and MCN?",
  "Find hub mapped to pincode 110037",
  "Check courier lane from 560001 to 122001",
  "How many non-serviceable pincodes are there currently?",
  "List serviceable pincodes in state Maharashtra with zone WEST1",
];

export const PINCODE_MAP_ASSISTANT_TEXT = {
  mapNoLocations: "No mappable locations found for this response.",
  noResponseGenerated: "No response was generated.",
  requestFailed: "Unable to reach the pincode assistant right now.",
  title: "Pincode Map Assistant",
  subtitle: "Ask coverage, hub mapping, lane serviceability",
  openAssistant: "Open Assistant",
  welcomeTitle: "Coverage Intelligence Assistant",
  welcomeDescription:
    "Ask about serviceability, hub mapping, or network coverage. Relevant results can be highlighted directly on the map.",
  inputPlaceholder: "Ask about pincode coverage and hub mapping...",
  showOnMapPrefix: "Show on map",
  userBubbleLabel: "You",
};

export const PINCODE_MAP_ASSISTANT_FOLLOWUP = {
  fallbackPrimaryPincode: "560001",
  fallbackSecondaryPincode: "122001",
  fallbackAlternatePincode: "110037",
};

export const getServiceabilityFollowUp = (pincode) =>
  `Is ${pincode} serviceable for courier, e-commerce, and MCN?`;

export const getCourierLaneFollowUp = (fromPincode, toPincode) =>
  `Check courier lane from ${fromPincode} to ${toPincode}`;

export const getHubMappingFollowUp = (pincode) =>
  `Find hub mapped to pincode ${pincode}`;

export const getShowOnMapLabel = (count) =>
  `${PINCODE_MAP_ASSISTANT_TEXT.showOnMapPrefix} (${count})`;
